import { MAP_TYPES } from '@deck.gl/carto';

const HISTORICALBIKERVOLUME_SOURCE_ID = 'historicalBikerVolumeSource';

const source = {
  id: HISTORICALBIKERVOLUME_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'historical_biker_volume_source',
};

export default source;
